module.exports = __webpack_public_path__ + "static/media/due-port06.ffaeac94.jpg";